<template lang="pug">
  b-modal#matchMappingInfo(
  ref="matchMappingInfoModal"
  :title="$t('ui.update_mapping')"
  centered
  no-fade
  size="lg"
  :busy="loading"
  @ok="done"
  @shown="reset")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div(v-if="info")
        div
          b-form-group(:label="$t('ui.duplicate_match_list')").mb-3
            div.row.mb-3(v-if="info").animated.fadeIn
              div.col
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th(width=80)
                        span {{ $t('ui.id') }}
                      th(width=80)
                        span {{ $tc('ui.sports', 1) }}
                      th
                        span {{ $tc("ui.leagues", 1) }}
                      th
                        span {{ $t("ui.home") }}
                      th
                        span {{ $t("ui.away") }}
                      th(width=60)
                        span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                      th(width=80)
                        span {{ $t("ui.short.match_date") }}
                      th(width=80)
                        span {{ $t("ui.short.match_time") }}
                      th(width=80)
                        span {{ $t("ui.sbo") }}
                      th(width=80)
                        span {{ $t("ui.ibc") }}
                  tbody.clusterize-content
                    tr(v-if="duplicateMatchList.length == 0")
                      td(colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in duplicateMatchList")
                      td
                        span {{ item.match_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span(:title="item.home_team") {{ item.home_team }}
                      td
                        span(:title="item.away_team") {{ item.away_team }}
                      td.text-uppercase
                        span {{ item.market_type }}
                      td
                        span {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                      td
                        span {{ item.match_time }}
                      td
                        span {{ item.sbo_map }}
                      td
                        span {{ item.ibc_map }}
        div
          b-form-group(:label="$t('ui.current_match')").mb-3
            div.row.mb-3(v-if="info").animated.fadeIn
              div.col
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th(width=80)
                        span {{ $t('ui.id') }}
                      th(width=80)
                        span {{ $tc('ui.sports', 1) }}
                      th
                        span {{ $tc("ui.leagues", 1) }}
                      th
                        span {{ $t("ui.home") }}
                      th
                        span {{ $t("ui.away") }}
                      th(width=60)
                        span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                      th(width=80)
                        span {{ $t("ui.short.match_date") }}
                      th(width=80)
                        span {{ $t("ui.short.match_time") }}
                      th(width=80)
                        span {{ $t("ui.sbo") }}
                      th(width=80)
                        span {{ $t("ui.ibc") }}
                  tbody.clusterize-content
                    tr
                      td
                        span {{ info.match_id }}
                      td
                        span {{ info.sport_type }}
                      td
                        span(:title="info.league_name") {{ info.league_name }}
                      td
                        span(:title="info.home_team") {{ info.home_team }}
                      td
                        span(:title="info.away_team") {{ info.away_team }}
                      td.text-uppercase
                        span {{ info.market_type }}
                      td
                        span {{ $moment(info.match_date).format("YYYY-MM-DD") }}
                      td
                        span {{ info.match_time }}
                      td
                        select(v-model="sboMatch" v-if="showSBOddl")
                          option(v-for="sboMatchInfo in sboMatchList" :value="sboMatchInfo.value")
                            | {{ sboMatchInfo.text }}
                        span {{ info.sbo_map }}
                      td
                        select(v-model="ibcMatch" v-if="showIBCddl")
                          option(v-for="ibcMatchInfo in ibcMatchList" :value="ibcMatchInfo.value")
                            | {{ ibcMatchInfo.text }}
                        span {{ info.ibc_map }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      duplicateMatchList: [],
      sboMatch: null,
      ibcMatch: null,
      showSBOddl: false,
      showIBCddl: false
    };
  },
  computed : {
    sboMatchList:
    {
      get()
      {
        var list = [];

        list.push({
          value: this.info.sbo_map,
          text: this.info.sbo_map
        });

        for (var i = 0; i < this.duplicateMatchList.length; i += 1) {
          list.push({
            value: this.duplicateMatchList[i].sbo_map,
            text: this.duplicateMatchList[i].sbo_map
          });
        }

        return list;
      },
      set(value)
      {
        this.value = value
      }
    },
    ibcMatchList:
    {
      get()
      {
        var list = [];
        list.push({
          value: this.info.ibc_map,
          text: this.info.ibc_map
        });

        for (var i = 0; i < this.duplicateMatchList.length; i += 1) {
          list.push({
            value: this.duplicateMatchList[i].ibc_map,
            text: this.duplicateMatchList[i].ibc_map
          });
        }

        return list;
      },
      set(value)
      {
        this.value = value
      }
    }
  },
  methods: {
    reset() {
      if(this.info) {
        this.sboMatchList = [];
        this.ibcMatchList = [];
        this.sboMatch = this.info.sbo_map,
        this.ibcMatch = this.info.ibc_map,
        this.getDuplicateMatchList();
      }
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      let url = config.updateMatchMappingUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.updatemapping,
        match_id: this.info.match_id,
        sbo_match: this.showSBOddl ? this.sboMatch : this.info.sbo_map,
        ibc_match: this.showIBCddl ? this.ibcMatch : this.info.ibc_map
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked", this.info.match_id, this.sboMatch, this.ibcMatch);
                this.$refs.matchMappingInfoModal.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "update_mapping", this.feedback.status);
                this.$refs.matchMappingInfoModal.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getDuplicateMatchList: function() {
      let url = config.duplicateMatchListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.updatemapping,
        match_id: this.info.match_id,
        league_id: this.info.league_id,
        home_id: this.info.home_id,
        away_id: this.info.away_id,
        sport_id: this.info.sport_id
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.duplicateMatchList = response.data.tbl_duplicate_match_list;
                this.showSBOddl = false;
                this.showIBCddl = false;

                for (var i = 0; i < this.duplicateMatchList.length; i += 1) {
                  if (!this.showSBOddl && this.duplicateMatchList[i].sbo_map && this.duplicateMatchList[i].sbo_map != '')
                    this.showSBOddl = true;

                  if (!this.showIBCddl && this.duplicateMatchList[i].ibc_map && this.duplicateMatchList[i].ibc_map != '')
                    this.showIBCddl = true;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
